import React from 'react';
import { JitsiMeeting } from '@jitsi/react-sdk';
import { IJitsiMeetExternalApi } from '@jitsi/react-sdk/lib/types';
import { IJitsiWrapperProps } from '../types';

const JitsiWrapper: React.FC<IJitsiWrapperProps> = ({
    domain,
    roomName,
    configOverwrite,
    interfaceConfigOverwrite,
    jwt,
    displayName,
    userEmailAddress,
    addOnIsVisible,
    handleJitsiMeetExternalAPILoad
}) => {
    return (
        <JitsiMeeting
            domain={domain}
            roomName={roomName}
            configOverwrite={configOverwrite}
            interfaceConfigOverwrite={interfaceConfigOverwrite}
            jwt={jwt}
            userInfo={{
                displayName,
                email: userEmailAddress
            }}
            onApiReady={(externalApi: IJitsiMeetExternalApi) => {
                handleJitsiMeetExternalAPILoad(externalApi);
            }}
            getIFrameRef={(iframeRef) => {
                if (!addOnIsVisible) {
                    iframeRef.style.width = '100%';
                    iframeRef.style.height = '100%';
                    iframeRef.style.minHeight = '100%';
                } else {
                    iframeRef.style.width = '360px';
                    iframeRef.style.height = '240px';
                    iframeRef.style.position = 'absolute';
                    iframeRef.style.zIndex = '3000';
                    iframeRef.style.float = 'left';
                    iframeRef.style.border = '1px solid #2a88d8';
                }
            }}
        />
    );
};

export default JitsiWrapper;
